import React from 'react';

import ActionButton from '../../builder/ActionButton';
import { getRemotedbUrl } from '../../../lib/ep';

const lb = '%0D%0A';	// line break

const SendByMail = (props) => {
	const url = props?.url ?? false;
	const share = props?.share ?? {};
	if(url == false) return null;

	const click = () => {
		const linkable = props?.linkable ?? true;
		if(!linkable) return;
		
		const subject = props?.subject ?? "";
		const post = props?.post ?? "";
	
		let mail_url_parts = [];
		if(subject != "") mail_url_parts.push(`subject=${subject}`);
		if(post != "") {
			mail_url_parts.push(`body=${post}${lb}${lb}${url}`);
		} else {
			mail_url_parts.push(`body=${url}`);
		}
		if(share.promotion_id != undefined) {
			$.post(getRemotedbUrl(`/users/sharebtn/${share.promotion_id}`), {
				network:5,
				page:share.page,
				type:share.type,
				uid:share?.user_id ?? null,
			});
		}

		window.location.href = `mailto:?${mail_url_parts.join("&")}`;
	};

	return (
		<ActionButton
			{...props}
			icon='ep-mail-square is_mail'
			onClick={() => click()}
		/>
	);
}

export default SendByMail;